module.exports = __webpack_public_path__ + "img/bg-1.75ae7a91.jpg";